import tw from "twin.macro";
export const PrimaryButton = tw.button`px-8 py-3 font-bold rounded bg-pbsOrange-500 text-gray-100 hocus:bg-pbsOrange-700 hocus:text-gray-200 focus:shadow-outline focus:outline-none transition duration-300`;
